import config from "../config";
import { SectionTitle } from "../components/UI";

export default function RefundPolicy() {
  return (
    <div style={{ background: "#f6f6f0", minHeight: '78vh', padding: '40px 18px' }}>
      <div style={{ maxWidth: 980, margin: '0 auto', padding: '28px 18px' }}>
        <h1 style={{ textAlign: 'center', fontSize: 56, margin: '6px 0 18px', fontFamily: "'Playfair Display', serif" }}>
          Refund policy
        </h1>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ maxWidth: 720 }}>
            <SectionTitle>Return Policy</SectionTitle>
            <ol style={{ marginTop: 12, color: '#555', lineHeight: 1.8 }}>
              <li>If products are damaged, we advise you not to collect damaged products from our transporter or Courier Partner.</li>
              <li>A relevant photo of the damaged goods should also be attached for proof in email. If not, the return of the product will not be processed.</li>
              <li>Shipping for damaged products is free.</li>
              <li>Your damaged product will be replaced within 7 working days from the day we receive the returned products.</li>
              <li>For any products for which a refund is to be given, the refund will be processed once the returned product has been received by us.</li>
            </ol>

            <div style={{ marginTop: 18, fontWeight: 800, color: '#222' }}>
              Kindly Note that Return or Refund is only Against Damage by Transporter and We Do Not Accept Return or Refund in any other Circumstance.
            </div>

            <div style={{ marginTop: 18, color: '#444' }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>How to request a refund</div>
              <p style={{ marginTop: 0 }}>
                Email us at <a href={`mailto:${config.email}`}>{config.email}</a> with your order number, photos of damaged items, and a short description. We will review and respond within 48 hours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
